<template>
  <v-autocomplete
    v-model="activeStock"
    :hint="activeStock.name"
    :items="stocks"
    item-text="name"
    item-value="symbol"
    :label="selectLabel"
    return-object
    single-line
    :disabled="isSaving"
    :loading="isSaving"
    @change="toggle"
  />
</template>

<script>
import { generateRandomId } from '@/utils/math';
import { stocksList } from '@/utils/stocks';
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'SelectStocks',
  mixins: [
    cardsModel,
  ],
  props: {
    itemId: {
      type: String,
      required: true,
    },
    stock: {
      type: Object,
      default: () => {
        return { name: '', symbol: '' };
      },
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isSaving: false,
      activeStock: this.stock,
      stocks: stocksList,
    };
  },
  computed: {
    selectLabel() {
      return this.$t('stocks.bovespa');
    },
  },
  methods: {
    toggle() {
      if (!this.activeStock) {
        this.activeStock = { name: 'VALE3', symbol: 'VALE3.SA' };
      }
      this.isSaving = true;
      setTimeout(() => {
        this.card.props.stock = this.activeStock;
        this.card.id = generateRandomId();
        this.saveCards().then(() => {
          this.isSaving = false;
        });
      }, 100);
    },
  },
};
</script>
